// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: lbG330E7q254
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicOnboardingPersonalFail.module.css"; // plasmic-import: lbG330E7q254/css
import CheckSvgIcon from "./icons/PlasmicIcon__CheckSvg"; // plasmic-import: NNWdipNv4a0I/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: cdQ-QsSHJP16/icon

createPlasmicElementProxy;

export const PlasmicOnboardingPersonalFail__VariantProps = new Array();

export const PlasmicOnboardingPersonalFail__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingPersonalFail__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__oArAg)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__q1Mqe
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__zFlSd)}>
            <div className={classNames(projectcss.all, sty.freeBox__fkW6)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__vxyQr)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__etReG)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fluU3)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__lpZkz)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__eQmG)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__xgc3V)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__aCpBk)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__dryRx)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___7Hto5)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__r5FXz)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__o0Znq)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yvIe
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qUZai
                )}
              >
                {"Personal Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hz8F5
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__iccNj
                )}
              >
                {"Retry & Submit"}
              </div>
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox__eC13M)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__p15Kn
                )}
              >
                {"Application Unapproved"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__x6Q6O
                )}
              >
                {
                  "Unfortunately, your account has not been approved due to issues with validating your identity. "
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "lineStack", "circle", "circle2", "circle3", "circle4"],
  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingPersonalFail__ArgProps,
          internalVariantPropNames: PlasmicOnboardingPersonalFail__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingPersonalFail__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingPersonalFail";
  } else {
    func.displayName = `PlasmicOnboardingPersonalFail.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingPersonalFail = Object.assign(
  // Top-level PlasmicOnboardingPersonalFail renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    // Metadata about props expected for PlasmicOnboardingPersonalFail
    internalVariantProps: PlasmicOnboardingPersonalFail__VariantProps,
    internalArgProps: PlasmicOnboardingPersonalFail__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingPersonalFail;
/* prettier-ignore-end */
